import { render, staticRenderFns } from "./aiEventList.vue?vue&type=template&id=6471aee4&scoped=true"
import script from "./aiEventList.vue?vue&type=script&lang=js"
export * from "./aiEventList.vue?vue&type=script&lang=js"
import style0 from "./aiEventList.vue?vue&type=style&index=0&id=6471aee4&prod&scoped=true&lang=scss"
import style1 from "./aiEventList.vue?vue&type=style&index=1&id=6471aee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6471aee4",
  null
  
)

export default component.exports